import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className", "cssModule", "tag", "active", "disabled", "action", "color"];
import React from 'react';
import classNames from 'classnames';
import { mapToCssModules, tagPropType } from './utils';
var defaultProps = {
  tag: 'li'
};
var handleDisabledOnClick = function handleDisabledOnClick(e) {
  e.preventDefault();
};
var ListGroupItem = function ListGroupItem(props) {
  var className = props.className,
    cssModule = props.cssModule,
    Tag = props.tag,
    active = props.active,
    disabled = props.disabled,
    action = props.action,
    color = props.color,
    attributes = _objectWithoutPropertiesLoose(props, _excluded);
  var classes = mapToCssModules(classNames(className, active ? 'active' : false, disabled ? 'disabled' : false, action ? 'list-group-item-action' : false, color ? "list-group-item-" + color : false, 'list-group-item'), cssModule); // Prevent click event when disabled.

  if (disabled) {
    attributes.onClick = handleDisabledOnClick;
  }
  return /*#__PURE__*/React.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
};
ListGroupItem.defaultProps = defaultProps;
export default ListGroupItem;